import { useTranslation } from "react-i18next";

import { Button } from "@/components/Interface/Button/Button";
import { Modal } from "@/components/Interface/Modal/Modal";
import { Notification } from "@/components/Interface/Notification/Notification";
import { ButtonGroupFlexBox } from "@/components/Layout/ButtonGroupFlexBox/ButtonGroupFlexBox";

type Props = {
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
  isConfirming?: boolean;
};

export const EsimInfoModal = ({
  onConfirm,
  onClose,
  isConfirming = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("portal:add-device.esimInfoModal.title")}
      onClose={onClose}
      hasScroll={false}
      variant="dark"
    >
      <div className="flex flex-col gap-6">
        <p className="text-body-base text-foreground-primary-inverse">
          {t("portal:add-device.esimInfoModal.description")}
        </p>

        <Notification
          inverted
          tone="info"
          title={t("portal:add-device.esimInfoModal.requirementTitle")}
          description={t("portal:add-device.esimInfoModal.requirementText")}
        />

        <ul className="list-outside list-disc space-y-2 pl-4 text-body-base text-foreground-primary-inverse">
          <li>{t("portal:add-device.esimInfoModal.benefits.instant")}</li>
          <li>{t("portal:add-device.esimInfoModal.benefits.noSwap")}</li>
          <li>{t("portal:add-device.esimInfoModal.benefits.multiTariff")}</li>
        </ul>

        <ButtonGroupFlexBox
          className="!mt-0"
          rightAligned
          forceButtonWidth
          primaryButton={
            <Button
              variant="primary"
              inverted
              loading={isConfirming}
              onClick={() => void onConfirm()}
            >
              {t("portal:add-device.esimInfoModal.confirm")}
            </Button>
          }
          secondaryButton={
            <Button
              variant="secondary"
              inverted
              disabled={isConfirming}
              onClick={onClose}
            >
              {t("Common.label.cancel")}
            </Button>
          }
        />
      </div>
    </Modal>
  );
};
